import { atom } from 'jotai'

export const tokenListAddingErrorAtom = atom<string | null>(null)
